import type { NextRouter } from 'next/router'

export const setQuery = async (router: NextRouter, params: { [key: string]: string | string[] }) => {
  const currentQuery = { ...router.query, ...params }

  return router.replace(
    {
      pathname: router.pathname,
      query: currentQuery,
    },
    undefined,
    { scroll: false }
  )
}
